"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = __importStar(require("@app/routes/SpeechDevelopment/components/Button"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const uiConfigs_1 = require("@app/constants/uiConfigs");
const exercise_1 = require("@components/container/exercise");
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
const useBeforeUnloadReport_1 = require("@hooks/useBeforeUnloadReport");
const ResponsiveStyles_1 = require("@components/typography/ResponsiveStyles");
const useText72Init_1 = require("@hooks/useText72Init");
const shuffle_1 = require("@app/utils/shuffle");
const ExercisePaginations_1 = require("@app/routes/SpeechDevelopment/components/ExercisePaginations");
const DropContainerWrapper = styled_components_1.default.div ` 
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    align-items: self-start;
    justify-content: end;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
    @media (max-width: 700px) {
        flex-wrap: wrap-reverse;
        margin-bottom: 10px;
    }
`;
const ReferenceArea = styled_components_1.default.div `
  margin: 16px;
  padding: 16px;
  border: 1px solid #000;
  width: fit-content;
  position: relative;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-sizing: border-box;
`;
const ReferenceTitle = styled_components_1.default.div `
  position: relative;
  background: transparent;
  padding: 5px 20px;
  border-radius: 25px;
  user-select: none;
  font-size: 24px;
  font-weight: 700;
  color: #6E76FB;
  font-family: Phenomena;
  white-space: nowrap;
  ${ResponsiveStyles_1.responsiveReferenceTitleStyles}
`;
const ReferenceGroupsGrid = styled_components_1.default.div `
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;;
    gap: 16px;
    width: 100%;
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
    
    @media (max-width: 540px) {
        grid-template-columns: 1fr;
    }
`;
const ReferenceGroup = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    padding: 8px;
    background-color: #fff;
    border-radius: 8px;
    min-height: 80px;
`;
const GroupContainer = styled_components_1.default.div `
    display: flex;
    margin: 10px;
    padding: 16px;
    flex-wrap: wrap;
    border: 1px solid #000;
    width: 100%;
    height: fit-content;
    background-color: #f9f9f9;
    border-radius: 8px;
    min-height: 100px;
    justify-content: start;
    align-items: start;
    box-sizing: border-box;
`;
const WordItem = styled_components_1.default.div `
  background: transparent;
  padding: 5px 20px;
  border: 1px dashed #6E76FB;
  border-radius: 25px;
  cursor: grab;
  user-select: none;
  font-size: 32px;
  font-weight: 700;
  color: #6E76FB;
  line-height: 21px;
  font-family: Phenomena;
  transition: background-color 0.2s ease-in-out, transform 0.1s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.isCorrect !== undefined && `
    border: ${props.isCorrect ? '1px dashed #3CB949' : '1px dashed #FE2B45'};
    color: ${props.isCorrect ? '#3CB949' : '#FE2B45'};
  `}

  img {
    max-width: 140px;
    max-height: 140px;
    object-fit: contain;
    display: block;
  }

  &:active {
    cursor: grabbing;
    transform: scale(0.98);
  }

  &:hover {
    background-color: #dcdcdc;
  }

  ${ResponsiveStyles_1.responsiveWordItemStyles}
`;
// @ts-ignore
const Word = ({ word, index, moveWord, groupIndex, isReference, isCorrect }) => {
    const uniqueKey = `${word.word}-${word.group}-${word.id}`;
    const [{ isDragging }, ref] = (0, react_dnd_1.useDrag)(() => ({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        type: "WORD",
        item: { uniqueKey, groupIndex },
        options: { dropEffect: 'move' },
    }));
    const [, drop] = (0, react_dnd_1.useDrop)({
        accept: "WORD",
        hover: (draggedItem) => {
            if (draggedItem.uniqueKey !== uniqueKey ||
                draggedItem.groupIndex !== groupIndex) {
                moveWord(draggedItem.uniqueKey, uniqueKey, draggedItem.groupIndex, groupIndex);
                draggedItem.groupIndex = groupIndex;
            }
        },
    });
    return (react_1.default.createElement(WordItem, { ref: (node) => ref(drop(node)), group: word.group, isCorrect: word === null || word === void 0 ? void 0 : word.isCorrect, isReference: isReference, isOver: false, style: {
            opacity: isDragging ? 0.5 : 1,
            cursor: isDragging ? 'grabbing' : 'grab'
        } }, !!word.hint ? (react_1.default.createElement("img", { src: word.hint, alt: word.word })) : (word.word)));
};
const Group = ({ group, words, moveWord }) => {
    const [, drop] = (0, react_dnd_1.useDrop)({
        accept: "WORD",
        drop: (draggedItem) => {
            const fromGroupIndex = draggedItem.groupIndex;
            const toGroupIndex = group - 1;
            if (fromGroupIndex !== toGroupIndex) {
                moveWord(draggedItem.uniqueKey, "", fromGroupIndex, toGroupIndex);
                draggedItem.groupIndex = toGroupIndex;
            }
        },
    });
    return (react_1.default.createElement(GroupContainer, { ref: drop }, words.map((word, index) => (react_1.default.createElement(Word, { key: `${word.word}-${word.group}-${index}`, word: word, index: index, moveWord: moveWord, isReference: false, groupIndex: group - 1 })))));
};
const Container = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    align-items: self-start;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
`;
let widthEl;
let infoRep = [];
let checkedAnswer = [];
const groupWordsByGroup = (words) => {
    return words.reduce((acc, word) => {
        const groupIndex = word.order - 1;
        if (!acc[groupIndex])
            acc[groupIndex] = [];
        acc[groupIndex].push(word);
        return acc;
    }, []);
};
const Text_7_2 = ({ response, description, langId }) => {
    var _a, _b;
    const { words, setWords, referenceWords, setReferenceWords } = (0, useText72Init_1.useText72Init)(response);
    const currentContainerRef = (0, react_1.useRef)(null);
    const [checkButtons, setCheckButtons] = (0, react_1.useState)(uiConfigs_1.initialButtonState);
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    (0, useBeforeUnloadReport_1.useBeforeUnloadReport)(() => ({
        infoRep: window.infoRep,
        exerciseId: (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id),
        checkedAnswer: window.checkedAnswer
    }));
    const handleAddCoin = () => addCoin(3, 5);
    console.log(response);
    const shuffledReferenceWords = (0, react_1.useMemo)(() => {
        var _a;
        return ((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.text_type) === 'voice_picture'
            ? (0, shuffle_1.shuffleArray)(referenceWords)
            : referenceWords;
    }, [referenceWords, (_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.text_type]);
    const moveWord = (fromIndex, toIndex, fromGroupIndex, toGroupIndex) => {
        const updatedWords = [...words];
        let movedWord;
        const updatedReferenceWords = [...referenceWords];
        if (fromGroupIndex === -1) {
            const fromIndexUpdWord = updatedReferenceWords.findIndex((w) => `${w.word}-${w.group}-${w.id}` === fromIndex);
            if (fromIndexUpdWord !== -1) {
                [movedWord] = updatedReferenceWords.splice(fromIndexUpdWord, 1);
            }
            else {
                console.error(`Ошибка: слово с ключом ${fromIndex} не найдено в ReferenceArea`);
                return;
            }
        }
        else if (fromGroupIndex >= 0 && fromGroupIndex < updatedWords.length) {
            const fromIndexUpdWord = updatedWords[fromGroupIndex].findIndex((w) => `${w.word}-${w.group}-${w.id}` === fromIndex);
            if (fromIndexUpdWord !== -1) {
                [movedWord] = updatedWords[fromGroupIndex].splice(fromIndexUpdWord, 1);
            }
            else {
                return;
            }
        }
        else {
            console.error(`Ошибка: некорректный fromGroupIndex ${fromGroupIndex}`);
            return;
        }
        if (!movedWord) {
            console.error(`Ошибка: перемещаемое слово не определено (${fromIndex})`);
            return;
        }
        if (toGroupIndex >= 0 && toGroupIndex < updatedWords.length) {
            const group = updatedWords[toGroupIndex];
            let toIndex = -1;
            if (toIndex) {
                toIndex = group.findIndex((w) => `${w.word}-${w.group}-${w.id}` === toIndex.toString());
                if (toIndex !== -1) {
                    group.splice(toIndex, 0, movedWord);
                }
                else {
                    group.push(movedWord);
                }
            }
            else {
                group.push(movedWord);
            }
        }
        else {
            updatedReferenceWords.push(movedWord);
        }
        setReferenceWords(updatedReferenceWords);
        setWords(updatedWords);
    };
    const checkSentence = () => {
        const checkCorrectSubArray = (subArray) => {
            if (subArray.length === 0)
                return [];
            const uniqueGroups = new Set(subArray.map(word => word.group));
            const isMixedGroups = uniqueGroups.size > 1;
            if (isMixedGroups) {
                return subArray.map((word, index) => {
                    const isCorrect = (index === 0 && word.order === 1) || (word.isCorrect === true && word.order === 1);
                    console.log(`Mixed groups - Word: ${word.word}, Group: ${word.group}, Order: ${word.order}, Index: ${index}, IsCorrect: ${isCorrect}`);
                    return Object.assign(Object.assign({}, word), { isCorrect });
                });
            }
            else {
                const groupWords = [...subArray];
                const correctOrder = [...groupWords].sort((a, b) => a.order - b.order);
                return subArray.map((word, index) => {
                    const expectedOrder = correctOrder[index].order;
                    const isCorrect = word.order === expectedOrder;
                    console.log(`Single group - Word: ${word.word}, Group: ${word.group}, Order: ${word.order}, Expected: ${expectedOrder}, IsCorrect: ${isCorrect}`);
                    return Object.assign(Object.assign({}, word), { isCorrect });
                });
            }
        };
        const updatedSentence = words.map(subArray => {
            return checkCorrectSubArray(subArray);
        });
        setWords(updatedSentence);
        const isAllCorrect = updatedSentence.every(subArray => subArray.length === 0 || subArray.every(word => word.isCorrect === true));
        infoRep = (0, sendInfoReport_1.trackAttemptTime)(infoRep, isAllCorrect);
        if (isAllCorrect) {
            handleAddCoin();
            audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, "correct"));
            // @ts-ignore
            window === null || window === void 0 ? void 0 : window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
            // @ts-ignore
            (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
        }
        else {
            audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 318));
            infoRep = [...infoRep, { rep_id: infoRep.length + 1, category_name: '', system_time: '', startTime: Date.now() }];
        }
        return isAllCorrect;
    };
    const handleCheckButtonClick = () => {
        setCheckButtons((prevButtons) => {
            const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
            if (indexToUpdate === -1)
                return prevButtons;
            const updatedButtons = prevButtons.map((button, index) => {
                if (index === indexToUpdate) {
                    if (indexToUpdate === (checkButtons === null || checkButtons === void 0 ? void 0 : checkButtons.length) - 1) {
                        // @ts-ignore
                        window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                        // @ts-ignore
                        (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                    }
                    return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: checkSentence() });
                }
                return button;
            });
            checkedAnswer = updatedButtons;
            return updatedButtons;
        });
    };
    (0, react_1.useLayoutEffect)(() => {
        const updateContainerWidth = () => {
            if (currentContainerRef.current) {
                widthEl = currentContainerRef.current.clientWidth;
            }
        };
        updateContainerWidth();
        window.addEventListener('resize', updateContainerWidth);
        return () => {
            window.removeEventListener('resize', updateContainerWidth);
        };
    }, []);
    const paginationData = checkButtons.map((item, index) => (Object.assign(Object.assign({}, item), { id: item.index || index + 1 })));
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            react_1.default.createElement(exercise_1.ExerciseWrapper, null,
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(Container, { ref: currentContainerRef }, words.map((groupWords, groupIndex) => (react_1.default.createElement(Group, { key: `group-${groupIndex}`, group: groupIndex + 1, words: groupWords, moveWord: moveWord })))),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(ReferenceArea, null,
                    react_1.default.createElement(ReferenceTitle, null, "\u0421\u043B\u043E\u0432\u0430 \u0434\u043B\u044F \u0441\u043F\u0440\u0430\u0432\u043E\u043A:"),
                    ((_b = response === null || response === void 0 ? void 0 : response.text) === null || _b === void 0 ? void 0 : _b.text_type) === 'voice_picture' ? (react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', gap: 16, justifyContent: 'center', alignItems: 'center' } }, shuffledReferenceWords.map((word, index) => (react_1.default.createElement(Word, { key: `${word.id}-${index}`, word: word, index: index, moveWord: moveWord, groupIndex: -1, isReference: true }))))) : (react_1.default.createElement(ReferenceGroupsGrid, null, groupWordsByGroup(referenceWords).map((group, groupIndex) => (react_1.default.createElement(ReferenceGroup, { key: `reference-group-${groupIndex}` }, group.map((word, index) => (react_1.default.createElement(Word, { key: `${word.word}-${index}`, word: word, index: index, moveWord: moveWord, groupIndex: -1, isReference: true }))))))))),
                react_1.default.createElement(ExercisePaginations_1.ExercisePagination, { answersFrameArray: paginationData })),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(Button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(Button_1.default, { isShowShadow: false, label: (0, translations_1.getLabelCheckButton)(langId), onClick: handleCheckButtonClick, isCheckButton: true }))))));
};
exports.default = Text_7_2;
